/**
 * Google reCAPTCHA v2 Configuration
 * Get your site key from: https://www.google.com/recaptcha/admin
 */

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

/**
 * Validate that reCAPTCHA is properly configured
 */
export const isRecaptchaConfigured = (): boolean => {
  if (!RECAPTCHA_SITE_KEY) {
    console.error('REACT_APP_RECAPTCHA_SITE_KEY is not configured in environment variables');
    return false;
  }
  return true;
};
